const SearchSynopsisTerms = `
  searchSynopsisTerms {
    label
    operator
    path
    values {
      label
      path
      value
    }
  }
`;

export default SearchSynopsisTerms;
